import { render } from "./ImportComponent.vue?vue&type=template&id=21aa6ffa"
import script from "./ImportComponent.vue?vue&type=script&lang=js"
export * from "./ImportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/import/ImportComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21aa6ffa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21aa6ffa', __exports__)) {
    api.reload('21aa6ffa', __exports__)
  }
  
  module.hot.accept("./ImportComponent.vue?vue&type=template&id=21aa6ffa", () => {
    api.rerender('21aa6ffa', render)
  })

}


export default __exports__